export default __webpack_public_path__ + "static/img/falls-pediatrics-uc-granite-falls.928fb7b.jpg";